import React from 'react'
import PropTypes from 'prop-types'

import { IMaskInput } from 'react-imask'

import styles from './../style/Reviews.module.scss'
import form_styles from './../style/Form.module.scss'

import { Container, Image, Form, Modal } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'

import axios from 'axios'

class Reviews extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      name: ``,
      phone: ``,
      email: ``,
      message: ``,
      show_msg: false,
      modal_body: ``,
      isSending: false
    }
  }

  changeName( name ) {
    this.setState({
      name: name
    })
  }

  changePhone( phone ) {
    this.setState({
      phone: phone
    })
  }

  changeEmail( email ) {
    this.setState({
      email: email
    })
  }

  changeMessage( message ) {
    this.setState({
      message: message
    })
  }

  handleShow_msg( text ) {
    this.setState({
      show_msg: true,
      modal_body: text
    })
  }
  
  handleClose_msg() {
    this.setState({
      show_msg: false
    })
  }

  sendForm = ( e ) => {
    e.preventDefault()

    const { name, phone, email, message, isSending } = this.state

    // Если уже идет отправка, ничего не делаем
    if (isSending) return;

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    
    // Устанавливаем состояние отправки
    this.setState({ isSending: true })
    
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': 'Есть идея или вопрос',
      'name': name,
      'phone': phone,
      'json': JSON.stringify([
        {
          name: `E-mail`,
          value: email
        },
        {
          name: `Сообщение`,
          value: message
        }
      ])
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.handleShow_msg( `Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.` )
        // Очищаем форму после успешной отправки
        this.setState({
          name: ``,
          phone: ``,
          email: ``,
          message: ``
        })
      } else {
        main.handleShow_msg( `Заполните поля формы` )
      }
    }).catch(error => {
      // Показываем сообщение об ошибке
      main.handleShow_msg( `Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.` )
      console.error('Error sending form:', error)
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      this.setState({ isSending: false })
    })
  }

  render() {

    const { data, logo, sitename, assets_path, margin, text } = this.props
    const { show_msg, modal_body, isSending, name, phone, email, message } = this.state

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
          />
          {text != `` &&
            <div className={styles.section_text}>{text}</div>
          }
          <div className={styles.content}>
            <div className={styles.left}>
              <div className={styles.header}>
                <a className={styles.logo} href="/">
                  <Image
                    className={styles.logo_img}
                    width={27}
                    height={35}
                    alt={sitename}
                    src={logo}
                  />
                  <div className={styles.sitename}>{sitename}</div>
                </a>
                <div className={styles.yaotz}>
                  Официальные отзывы<br />
                  от компании
                  <svg width="67" height="20" viewBox="0 0 67 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 0C15.5223 0 20 4.47769 20 10C20 15.5223 15.5223 20 10 20C4.47769 20 0 15.5223 0 10C0 4.47769 4.47769 0 10 0Z" fill="#FC3F1D"/>
                    <path d="M11.3881 15.7497H13.4773V3.75196H10.4377C7.38141 3.74919 5.77431 5.32026 5.77431 7.63392C5.77431 9.48208 6.65544 10.5682 8.22652 11.6904L5.5 15.747H7.76101L10.7979 11.2055L9.74494 10.499C8.46758 9.63724 7.84691 8.96393 7.84691 7.512C7.84691 6.23464 8.74467 5.37013 10.4543 5.37013H11.3853L11.3881 15.7497Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M30.0572 5.95812H29.2552C27.7848 5.95812 27.0162 6.69693 27.0162 7.79396C27.0162 9.0365 27.5509 9.613 28.6481 10.3574L29.5503 10.9619L26.9382 14.8574H25L27.3448 11.3761C25.997 10.4134 25.2395 9.47867 25.2395 7.8947C25.2395 5.90775 26.6207 4.56445 29.244 4.56445H31.8506V14.8574H30.0572V5.95812Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M44.6397 13.4701H42.1501C42.6402 12.3451 42.7739 10.3133 42.7739 9.02602V8.80213H44.6452V13.4701H44.6397ZM46.4052 7.41406H41.2589V8.05213C41.2589 9.87117 41.142 12.2275 40.5182 13.4701H39.9668V16.5653H41.5987V14.8637H45.5586V16.5653H47.1905V13.4701H46.4052V7.41406Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M37.4594 10.3581H35.1034V7.41406H33.3379V14.8637H35.1034V11.7518H37.4594V14.8637H39.2249V7.41406H37.4594V10.3581Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M64.7862 8.65539C65.4713 8.65539 66.1341 8.89047 66.4905 9.11435V7.61993C66.1174 7.41284 65.4657 7.26172 64.5913 7.26172C62.3356 7.26172 61.166 8.87367 61.166 11.1405C61.166 13.6312 62.3078 15.0081 64.6693 15.0081C65.488 15.0081 66.0617 14.8625 66.4961 14.5491V13.1106C66.0505 13.4241 65.5159 13.6144 64.7751 13.6144C63.5164 13.6144 62.9928 12.6349 62.9928 11.0957C62.9928 9.48375 63.6333 8.65539 64.7862 8.65539Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M60.928 7.41406H59.1458L56.6562 10.8507V7.41406H54.8906V14.8637H56.6562V11.2033L59.2683 14.8637H61.2678L58.4329 10.8507L60.928 7.41406Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M51.906 10.4632H49.4443C49.4889 9.27666 49.9177 8.65539 50.7643 8.65539C51.6387 8.65539 51.906 9.383 51.906 10.3121V10.4632ZM50.7977 7.26172C48.6478 7.26172 47.623 8.90726 47.623 11.1573C47.623 13.7487 48.8985 15.0081 51.1542 15.0081C52.2792 15.0081 53.1146 14.7114 53.6326 14.3588V12.9203C53.0812 13.2898 52.1622 13.6144 51.3045 13.6144C50.0124 13.6144 49.5223 13.0099 49.4499 11.7618H53.705V10.827C53.705 8.2412 52.5633 7.26172 50.7977 7.26172Z" fill="white"/>
                  </svg>
                </div>
              </div>
              <div className={styles.iframe} dangerouslySetInnerHTML={{__html: data?.iframe}} />
            </div>
            <div className={styles.right}>
              <Image className={styles.right_image} src={data?.image} width={675} height={420} alt={`goodwin`} />
              <div className={styles.right_content}>
                <div className={styles.right_title} dangerouslySetInnerHTML={{__html: data?.form_title}} />
                <div className={styles.right_text} dangerouslySetInnerHTML={{__html: data?.form_text}} />
                <Form onSubmit={( e ) => this.sendForm( e )}>
                  <div className={styles.right_form}>
                    <div className={styles.right_form_left}>
                      <div className={form_styles.form_input_block + ` w-100`}>
                        <Image src={`/${assets_path}/images/user.svg`} width={14} height={14} alt="имя" />
                        <Form.Control
                          className={form_styles.form_input}
                          name="name"
                          required
                          value={name}
                          onChange={( e ) => this.changeName( e.target.value )}
                          type="text"
                          placeholder="Ваше имя"
                        />
                      </div>
                      <div className={form_styles.form_input_block + ` w-100`}>
                        <Image src={`/${assets_path}/images/form_phone.svg`} width={14} height={14} alt="тел." />
                        <Form.Control
                          className={form_styles.form_input}
                          name="phone"
                          required
                          value={phone}
                          onChange={( e ) => this.changePhone( e.target.value )}
                          as={IMaskInput}
                          mask="+{7} (000) 000-00-00"
                          lazy={true}
                          type="text"
                          placeholder="+7 (___) ___-__-__"
                        />
                      </div>
                      <div className={form_styles.form_input_block + ` w-100`}>
                        <Image src={`/${assets_path}/images/sms.svg`} width={16} height={16} alt="email" />
                        <Form.Control
                          className={form_styles.form_input}
                          name="email"
                          required
                          value={email}
                          onChange={( e ) => this.changeEmail( e.target.value )}
                          type="email"
                          placeholder="Ваша электронная почта"
                        />
                      </div>
                    </div>
                    <Form.Control
                      as="textarea"
                      className={styles.right_form_textarea}
                      placeholder={`Текст обращения`}
                      value={message}
                      onChange={( e ) => this.changeMessage( e.target.value )}
                      required
                    />
                  </div>
                  <div className={styles.right_form_btns}>
                    <GreenButton
                      text={isSending ? 'Отправляется...' : `Отправить обращение`}
                      width={204}
                      action={() => {  }}
                      submit={true}
                      disabled={isSending}
                    />
                    <div className={form_styles.form_pconf + ` mt-0`}>
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="17" height="17" rx="8.5" fill="white"/>
                        <rect x="4" y="4" width="9" height="9" rx="4.5" fill="#00C775"/>
                      </svg>
                      <div>Нажимая на кнопку, вы соглашаетесь с <a href="/privacy">политикой конфиденциальности</a></div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Container>
        <Modal centered show={show_msg} onHide={() => this.handleClose_msg()}>
          <Modal.Header closeButton>
            <Modal.Title>Сообщение</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='modal-text mt-2'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </section>
    )
  }
}

Reviews.propTypes = {
  data: PropTypes.object,
  logo: PropTypes.string,
  sitename: PropTypes.string,
  assets_path: PropTypes.string,
  margin: PropTypes.string,
  text: PropTypes.string
}

Reviews.defaultProps = {
  data: {},
  logo: ``,
  sitename: ``,
  assets_path: ``,
  margin: `bottom`,
  text: ``
}

export default Reviews